const navigationLinks = [
  {
    id: 1,
    title: 'home',
    route: '/',
    isExternal: false,
  },
  {
    id: 2,
    title: 'source code',
    route: 'https://github.com/gvgesanto2/microverse-soccer-players',
    isExternal: true,
  },
];

export default navigationLinks;
